<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditLandmark
            ? $t("settings.landmark.updateLandmark")
            : $t("settings.landmark.newLandmark")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <v-row align="center">
            <v-col cols="12">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  v-model="areaId"
                  :error-messages="errors"
                  :items="areaItems"
                  item-text="nameEn"
                  item-value="_id"
                  :search-input.sync="search"
                  outlined
                  dense
                  :label="$t('settings.area.title')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.title") }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.en')})`"
                  color="secondary"
                  type="text"
                  v-model="landmarkModelObj.nameEn"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.en") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.ar')})`"
                  color="secondary"
                  type="text"
                  v-model="landmarkModelObj.nameAr"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.ar") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-layout wrap>
            <v-flex xs12 sm4 md3 lg2 mt-2>
              <span class="red--text"><strong>* </strong></span>
              <h4 class="black--text text-body-2">
                {{ $t("settings.landmark.selectLocation") }}
              </h4>
            </v-flex>
            <v-flex xs12 sm8 md12 lg8>
              <google-map
                class="mx-auto"
                :center="addressCoordinates"
                :zoom="12"
                style="width: 75%; height: 200px"
                @selectedAddress="getSelectedAddress"
                :key="reRender"
              />
              <VueGooglePlaces
                :api-key="GOOGLE_MAP_API_KEY"
                class="subheading"
                v-model="searchPlace"
                @placechanged="getAddressData"
              >
                <v-text-field
                  outlined
                  rounded
                  dense
                  class="pt-4"
                  @change="changePlace"
                  prepend-inner-icon="mdi-map-marker"
                  label="Location"
                  v-model="address"
                >
                </v-text-field>
              </VueGooglePlaces>
              <!-- :rules="[requiredValidator('location')]" -->
            </v-flex>
          </v-layout>
          <v-row>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  disabled
                  :label="$t('settings.landmark.latitude')"
                  color="secondary"
                  type="number"
                  v-model="landmarkModelObj.latitude"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.landmark.latitude") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  disabled
                  :label="$t('settings.landmark.longitude')"
                  color="secondary"
                  type="number"
                  v-model="landmarkModelObj.longitude"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.landmark.longitude") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <!-- <v-col cols="3">
              <div class="d-flex justify-space-around">
                <v-btn
                width="100%" class="primary rounded-lg text-none" @click="onCancel">
                  {{ $t("common.cancel") }}
                </v-btn>
            </v-col> -->
            <v-col cols="9">
              <v-btn
                width="100%"
                class="white--text rounded-lg"
                color="primary"
                type="submit"
                :loading="btnLoading"
              >
                {{ isEditLandmark ? $t("common.update") : $t("common.save") }}
              </v-btn>
            </v-col>
          </v-row>
          <!-- </div> -->
          <!-- </v-col> -->
          <v-col v-if="isError != null" cols="12" sm="12"
            ><Alert :message="isError" />
          </v-col>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { createLandmark } from "../../methods/landmark/create_landmark";
import { updateLandmark } from "../../methods/landmark/update_landmark";

export default {
  data() {
    return {
      GOOGLE_MAP_API_KEY: "AIzaSyCfmLa-BRLoYmupAvEtTopYQPB-VVJeRrk",
      address: "",
      searchPlace: "",
      addressCoordinates: {
        lat: 25.2346289,
        lng: 55.43636900000001
      },
      btnLoading: false,
      landmarkModelObj: {
        nameEn: "",
        nameAr: "",
        areaId: "",
        latitude: "",
        longitude: ""
      },
      areaId: null,
      areaItems: [],
      search: "",
      isError: null,
      name: "",
      reRender: 0
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditLandmark) {
      this.landmarkModelObj = this.$format.cloneVariable(this.editLandmark);
      this.areaId = this.landmarkModelObj.area._id;
      this.addressCoordinates.lat = this.landmarkModelObj.latitude;
      this.addressCoordinates.lng = this.landmarkModelObj.longitude;
    }
  },
  watch: {
    isEditLandmark: {
      handler() {
        if (this.isEditLandmark) {
          this.landmarkModelObj = this.$format.cloneVariable(this.editLandmark);
          this.areaId = this.landmarkModelObj.area._id;
          this.addressCoordinates.lat = this.landmarkModelObj.latitude;
          this.addressCoordinates.lng = this.landmarkModelObj.longitude;
        } else {
          this.landmarkModelObj = {
            nameEn: "",
            nameAr: "",
            areaId: "",
            latitude: "",
            longitude: ""
          };
          this.areaId = null;
          this.reRender++;
        }
      },
      deep: true
    },
    search(val) {
      this.$apollo
        .query({
          query: require("@/settings/api/queries/area/area_query.graphql"),
          variables: {
            input: {
              limit: 0,
              skip: 0
            },
            filter: {
              searchKey: val
            }
          }
        })
        .then(data => {
          if (data.data.getAreas.areas)
            this.areaItems = data.data.getAreas.areas;
        });
    }
  },
  computed: {
    ...mapGetters(["isEditLandmark", "editLandmark"])
  },
  methods: {
    getSelectedAddress(data) {
      console.log(data);
    },
    getAddressData(data) {
      this.address = data.formatted_address;
      this.landmarkModelObj.latitude = data.latitude;
      this.landmarkModelObj.longitude = data.longitude;
      this.addressCoordinates = {
        lat: data.latitude,
        lng: data.longitude
      };
    },
    changePlace() {
      //
    },
    async onSave() {
      this.btnLoading = true;
      const inputObj = this.$format.cloneVariable(this.landmarkModelObj);
      inputObj.latitude = Number(inputObj.latitude);
      inputObj.longitude = Number(inputObj.longitude);
      const input = {
        input: inputObj
      };
      input.input.areaId =
        typeof this.areaId === "string" ? this.areaId : this.areaId._id;
      if (!this.isEditLandmark) {
        createLandmark(input).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchLandmark");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
            this.landmarkModelObj = {
              nameEn: "",
              nameAr: "",
              areaId: "",
              latitude: "",
              longitude: ""
            };
            this.areaId = null;
            this.reRender++;
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      } else {
        const updateInput = {
          landmarkId: input.input._id,
          input: {
            areaId: input.input.areaId,
            latitude: input.input.latitude,
            longitude: input.input.longitude,
            nameEn: input.input.nameEn,
            nameAr: input.input.nameAr
          }
        };
        updateLandmark(updateInput).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchLandmark");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_LANDMARK", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      }
    },
    onCancel() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$store.commit("IS_EDIT_LANDMARK", false);
    }
  }
};
</script>
